import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import {
  RecordingRulesStatus,
  RecordingRulesStatusSkeleton,
} from "@/k8s-clusters/components/recording-rules-status";

export const Route = createFileRoute(
  "/app/organization/$id/settings/k8s-metrics"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id: organizationId } = Route.useParams();

  return (
    <Suspense fallback={<RecordingRulesStatusSkeleton />}>
      <RecordingRulesStatus
        organizationId={organizationId}
      />
    </Suspense>
  );
}
